module.exports = __webpack_public_path__ + "static/media/logo-ecobrite.ec70c742.png";